<template>
    <div class="full-screen">

        <div class="saving" v-if="this.loading">
            <div class="loader"></div>
        </div>

        <a @click="$router.go(-1)" class="close"><span class="close__title">Esc</span></a>

        <div class="add-pharmacy-wrapper">

            <div class="pre-title">Выберите Аптеки</div>

            <div class="select-holder">
                <!--<input type="checkbox" class="checkbox"  name="selected-variant" id="auto" v-model="autoTitleIsOn">-->
                <!--<label for="auto" class="label label&#45;&#45;checkbox">Только с измненениями</label>-->



                <select-material
                        :isMulti="true"
                        :title="`Аптека`"
                        :possibleValues="pharmacies"
                        :allowSearch="false"
                        @select="pharmaciesSelected = $event"
                ></select-material>


            </div>




            <div class="" style="text-align: center; margin-top: 20px;">

                <a href="#" @click.prevent="save()" class="button">Отправить</a>

            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import selectMaterial from '../html/SelectMaterial';


export default {
  name: 'version-add',
  created() {
    this.loadPharmacies();
  },
  methods: {
    loadPharmacies() {
      const that = this;
      axios.get('/api/v2/pharmacies/?is_template=false').then((response) => {
        that.pharmacies = response.data;
      });
    },

    save() {
      const self = this;
      const data = { pharmacies: this.pharmaciesSelected };

      self.loading = true;
      axios.post('/api/v2/versions/', data).then(() => {
        self.loading = false;
        self.returnBack();
      });
    },
    returnBack() {
      this.$router.push('../');
    },
  },
  data() {
    return {
      loading: false,
      pharmacies: [],
      pharmaciesSelected: [],
    };
  },
  components: { selectMaterial },
};
</script>

<style >
    .select-holder {
        width: 500px;
        margin: 0 auto 40px;
        text-align: center;
    }
    .select-holder .material-select__title{
        width: 500px;
    }

    .select-holder .material-select__values {
        width: 500px;
        max-width: 500px;
    }

    .saving {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #ccc;
        z-index: 10000;
    }


    .loader {
        position: fixed;
        left: 50%;
        top: 50%;
        margin: -20em 0 0 -20em;
    }
</style>


// WEBPACK FOOTER //
// VersionAdd.vue?dfe3938e